import 'twin.macro';
import _groupBy from 'lodash-es/groupBy';
import SchoolyearLink from '@teetsh/app/src/components/Link/SchoolyearLink';
import { format } from '@teetsh/app/src/utils/time/format';
import React from 'react';
import { Absence } from '@teetsh/app/src/queries/appels/useAppelsAbsences';
import { isoDatePatternWithSlashes } from 'utils/time/datePatterns';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';
import parse from 'utils/time/parse';
import { UserLocale } from '@teetsh/app/src/types/user';

interface Props {
  absences: Absence[];
  print?: boolean;
}

export function AbsencesList(props: Props) {
  const { absences, print } = props;
  const { t } = useTranslation(['registreAppel', 'common']);
  const groupedByDateAbsences = _groupBy(absences, abs =>
    format(abs.date, 'fr-FR', t('common:datePattern.dd/MM/yy')),
  );
  const groupedByDateAbsencesEntries = Object.entries(groupedByDateAbsences);
  return (
    <ul role="list" tw="divide-y divide-gray-100">
      {groupedByDateAbsencesEntries.map(([date, abs]) => (
        <li
          key={date}
          css={[
            tw`flex items-center justify-between gap-x-6 py-5`,
            print && tw`py-2`,
          ]}
        >
          <div tw="min-w-0">
            <div tw="flex items-start gap-x-3">
              <p tw="text-sm font-semibold leading-6 text-neutral-intense">
                {format(
                  parse(date, t('common:datePattern.dd/MM/yy'), new Date()),
                  t('common:locale.long') as UserLocale,
                  t('common:datePattern.EEEE_dd_MMMM_yyyy'),
                )}{' '}
              </p>
              {abs.map(a => {
                if (a.type === 'morning') {
                  return (
                    <p
                      key={a.type}
                      css={[
                        tw`text-brand-intense bg-brand-quiet ring-brand-intense/20`,
                        tw`rounded-md whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset`,
                      ]}
                    >
                      {t('registreAppel:morningWithoutEmoji')}
                    </p>
                  );
                }
                return (
                  <p
                    key={a.type}
                    css={[
                      tw`text-warning-intense bg-warning-quiet ring-warning-quiet/20`,
                      tw`rounded-md whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset`,
                    ]}
                  >
                    {t('registreAppel:afternoonWithoutEmoji')}
                  </p>
                );
              })}
            </div>
          </div>
          {!print && (
            <div tw="flex flex-none items-center gap-x-4">
              <SchoolyearLink
                tw="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-neutral-intense shadow-sm ring-1 ring-inset ring-neutral-quiet hover:bg-neutral-white sm:block"
                to={`registre-appel/appels/${format(
                  abs[0].date,
                  'fr-FR',
                  isoDatePatternWithSlashes,
                )}`}
              >
                {t('registreAppel:voirLappel')}
              </SchoolyearLink>
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
